<template>
  <div id="error">
    <h1 class="head">The site cannot be built correctly:</h1>
    <h2 class="reason">{{ reason }}</h2>
    <button type="button" class="btn btnDarkWhite btnRound btnRefresh" @click.prevent.stop="retry">REFRESH</button>
    <ToastMessage v-if="toastMessage"
      :message="toastMessage"
      @close="setToastMessage(null)" />
  </div>
</template>

<script>
import ToastMessage from '@/components/Util/ToastMessage'

export default {
  name: 'Error',
  components: {
    ToastMessage
  },
  computed: {
    lastRoute () {
      return this.$store.state.system.lastRoute
    },
    reason () {
      return this.$route.params.reason
    }
  },
  data () {
    return {
      toastMessage: null
    }
  },
  methods: {
    setToastMessage (message) {
      this.toastMessage = message
    },
    retry () {
      if (!navigator.onLine) {
        // alert('네트워크 연결을 확인해주세요.')
        this.setToastMessage('Please check your network connection.')
        return
      }

      this.$root.$emit('app:retry')

      if (this.lastRoute) {
        this.$router.replace(this.lastRoute)
      } else {
        this.$router.replace({ name: 'main' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 140px;
  background-color: $bg-default;
  background: linear-gradient(#fffbf7, #e8eaf1);
  .head {
    align-self: stretch;
    font-size: 1rem;
    color: $color-grey;
    &:before {
      content: "";
      display: block;
      height: 140px;
      background: url('~@/assets/img/ico_terrible_simple.svg') 50% 0 / auto 120px no-repeat;
    }
  }
  .reason {
    text-transform: uppercase;
    margin-bottom: 1em;
    font-size: 1.2em;
    font-weight: 900;
  }
  .btnRefresh {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    padding: 1em;
    border-radius: 12px;
    font-size: 1.2em;
    &:before {
      content: "";
      display: inline-block;
      width: 22px;
      height: 22px;
      margin-right: 8px;
      background: url('~@/assets/img/refresh-cw.png') 50% 50% / contain no-repeat;
      opacity: 0.2;
    }
  }
}
</style>
